import {
  Box,
  alpha,
  Stack,
  lighten,
  Divider,
  IconButton,
  Tooltip,
  styled,
  useTheme,
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import { useDashboardLayout } from '@/contexts/DashboardLayoutContext';
import HeaderUserbox from './Userbox';
// import HeaderMenu from './Menu';

interface Props {
  withSidebar: boolean;
}

const HeaderWrapper = styled(Box, { shouldForwardProp: (prop) => prop !== 'withSidebar' })<Props>(
  ({ theme, withSidebar }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.colors.alpha.white[100], 0.5)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${withSidebar ? theme.sidebar.width : 0};
            width: auto;
        }
  `,
);

const Header = ({ withSidebar }: Props) => {
  const { sidebarToggle, toggleSidebar } = useDashboardLayout();
  const theme = useTheme();

  return (
    <HeaderWrapper
      withSidebar={withSidebar}
      sx={{
        display: 'flex',
        alignItems: 'center',
        boxShadow:
          theme.palette.mode === 'light'
            ? `0 1px 0 ${alpha(
              lighten(theme.colors.primary.main, 0.7),
              0.15,
            )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
              theme.colors.alpha.black[100],
              0.2,
            )}, 0px 5px 22px -4px ${alpha(
              theme.colors.alpha.black[100],
              0.1,
            )}`,
      }}
    >
      <Stack
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
        sx={{
          direction: 'row',
          alignItems: 'center',
        }}
      >
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: 'none', xs: 'inline-block' },
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton
              color="primary"
              onClick={toggleSidebar}
            >
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
        {/* <HeaderMenu /> */}
      </Stack>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {/* <HeaderButtons /> */}
        <HeaderUserbox />

      </Box>
    </HeaderWrapper>
  );
};

export default Header;
